import { breakpoints, css } from '../../../styles/theme';
import { rem } from 'polished';
import { FilterBoxProps } from './index';

export const StylesAC = css<FilterBoxProps>`
    @media (min-width: ${breakpoints.md}px) {
        padding: ${rem(13)} ${rem(26)};
        ${({ isHomepage, theme }) => (isHomepage ? '' : `border-bottom: 2px solid ${theme.colors.grey1};`)}
    }

    /* grid fix on buttons */
    .filter-buttons-wrapper {
        & > button:nth-child(2) {
            max-width: unset;
        }

        .stock-generated-filter-button {
            min-width: unset;
            max-width: unset;
            max-height: unset;
            margin: 0;
        }

        .slider-over {
            .range-display {
                font-size: ${({ theme }) => theme.fontSizes.h4};
            }
        }

        .disp-inline {
            text-transform: uppercase;
            text-align: center;
            justify-content: center;
        }
    }

    .filterbox-extra-filters {
        .filter {
            &:not(.color-filter) {
                > div {
                    border: solid 1px ${({ theme }) => theme.colors.grey2};
                }
            }
        }
    }

    .filterbox-body {
        /* note: never use display in this selector or you will rewrite mobile logic */

        > div:nth-of-type(2) {
            grid-template-columns: 1fr;
            max-width: 50rem;
            width: 100%;

            @media (max-width: calc(${breakpoints.md}px - 0.1px)){
                display: flex;
                flex-direction: column;

                &.onMobile-hidden {
                    display: none;
                }
            }

            @media (max-width: ${rem(777)}) {
                flex-basis: 100%;
            }

            @media (min-width: ${breakpoints.md}px) {
                min-width: 19rem;
                margin-right: 2rem;
                margin-bottom: 2rem;
            }
        }
    }

    .filter-title {
        font-weight: bold;
        font-size: ${rem(16)};
    }

    h3,
    .geolocation-filter-label {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
        font-size: ${rem(16)};
        font-weight: 700;
    }

    .reset-filters--button {
        font-family: ${({ theme }) => theme.fonts.fontBase};
    }

    .frontpage-legaltext {
        color: ${({ theme }) => theme.colors.grey2};
        font-size: ${({ theme }) => theme.fontSizes.h6};
    }

    .filterbox-collapse-button {
        background: ${({ theme }) => theme.colors.grey1};
        border-radius: 0;
    }

`;
